import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface ReloadButtonProps {
  brand: string
  translationKey: string
  token: string
  startDate: string
  endDate: string
  language: string
}

export const ReloadButton: React.FC<ReloadButtonProps> = ({
  brand,
  translationKey,
  token,
  language,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const storedStartDate = localStorage.getItem('startDate')
  const storedEndDate = localStorage.getItem('endDate')
  const storedMeetingNumber = localStorage.getItem('meeting_number')
  const storedPassword = localStorage.getItem('password')

  return (
    <button
      className={`${
        brand === 'vidacaixa'
          ? 'bg-[#007EAE] hover:bg-[#036085] focus:bg-[#007EAE] focus:ring-4 focus:ring-[#cce5f0] focus:outline-none'
          : 'bg-generic-primary-500 hover:bg-generic-primary-400 focus:bg-generic-primary-500 focus:ring-4 focus:ring-generic-primary-200 focus:outline-none'
      } text-white py-2 px-4 rounded mt-2 w-[130px] h-[48px]`}
      onClick={() =>
        navigate(
          `/zoom/meeting/${token}?brand=${brand}&language=${language}&start_date=${storedStartDate}&end_date=${storedEndDate}&meeting_number=${storedMeetingNumber}&password=${storedPassword}`,
        )
      }
    >
      {t(translationKey)}
    </button>
  )
}
